module.exports = __webpack_public_path__ + "static/PersonaClick-3528f4221ec21a8e1c1e1d3925c6a9c4.png";